import axios from 'axios';
import { publicRuntimeConfig } from '../config';

const { recaptchaToken, commandOrdersUrl, commandOrdersApiKey } = publicRuntimeConfig.settings;

export const listProducts = async ({ storeId, sectorCommand, statusId, isDeleted, statusPin }) => {
    return new Promise((resolve, reject) => {
        // Verificar que grecaptcha esté disponible
        if (!window.grecaptcha || !window.grecaptcha.ready) {
            reject(new Error('reCAPTCHA no está cargado'));
            return;
        }

        window.grecaptcha.ready(async () => {
            try {
                const token = await window.grecaptcha.execute(recaptchaToken, { action: 'submit' });

                const { data } = await axios.request({
                    method: 'post',
                    url: `${commandOrdersUrl}/command/listProducts`,
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': commandOrdersApiKey,
                        'x-recaptcha-token': token,
                        'isfront': true
                    },
                    data: {
                        storeId,
                        sectorCommand,
                        statusId,
                        isDeleted,
                        statusPin
                    }
                });

                resolve(data);
            } catch (error) {
                console.error('Error listing products:', error);
                reject(error);
            }
        });
    });
};
